import React from 'react'

export const StudentList = () => {
  return (
    <div>StudentList</div>
  )
}
